module.exports = __webpack_public_path__ + "images/icons/icon-right-arrow-d969a974.svg";